import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TokenInterceptor } from '../interceptor/token.interceptor';
import { QuestionnaireFormComponent } from './questionnaire-form.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { DetailInfoFormPageStepsModule } from 'shared/detail-info-form-page-steps/detail-info-form-page-steps.module';
import { DetailInfoTypeModule } from 'shared/detail-info-type/detail-info-type.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { QuestionnaireService } from '../services/questionnaire.service';
import { SharedModule } from '../shared/shared.module';

@NgModule({

  declarations: [QuestionnaireFormComponent,],
  imports: [
    CommonModule, HttpClientModule, FormsModule, ReactiveFormsModule, BsDropdownModule,
    RecaptchaModule, SharedModule,
    DetailInfoTypeModule, DetailInfoFormPageStepsModule
  ],
  exports: [QuestionnaireFormComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    QuestionnaireService
  ]
})
export class QuestionnaireFormModule { }
